export default function (value: number) {
  if (!value) return '0 B';

  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(value) / Math.log(1024));

  return Math.round(value / Math.pow(1024, i)) + ' ' + sizes[i];
}
